import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Header } from '../../models/header.model';
import { ImageComponent } from '@teamfoster/sdk/image';

@Component({
    selector: 'app-header-content-page',
    imports: [ImageComponent],
    templateUrl: './header-content-page.component.html',
    styleUrl: './header-content-page.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderContentPageComponent {
  header = input<Partial<Header>>();
}
